import { createSlice } from '@reduxjs/toolkit';
const initialState = () => {
    return {
        threatActors: [],
        mitremappings:[],
        errors: [],
        dimensions:[],
        severities:[],
        availabledimensions:[],
    };
  };

const rsDataSlice = createSlice({
  name: 'rsData',
  initialState:initialState(),
  reducers: {
    setThreatActors(state, action) {
      state.threatActors = action.payload;
    },
    setMitreMappings(state, action) {
      state.mitremappings = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setDimensions(state, action) {
      state.dimensions = action.payload;
    },
    setSeverities(state, action) {
      state.severities = action.payload;
    },
    setAvailableDimensions(state, action) {
      state.availabledimensions = action.payload;
    },
    
  },
});

export const {
  setThreatActors,
  setMitreMappings,
  setErrors,
  setDimensions,
  setSeverities,
  setAvailableDimensions,
} = rsDataSlice.actions;

export const rsData = rsDataSlice.reducer;